// Lib
import * as Immutable from 'immutable';

// Constants
import { DRAG_START, DRAG_END, CLEAR_HOVER_EFFECT, FORCE_HOVER_EFFECT } from './draggingConstants';
import { DND_3D_EFFECTS_SET } from '../user/account/accountModal/interface/interfaceSettingsConstants';
import { USER_NAVIGATE } from '../../common/users/userConstants';
import { LINE_POINT_DRAG_START } from '../element/line/lineUiConstants';
import { ATTACH_MODE_END, ATTACH_MODE_START } from '../utils/dnd/dndConstants';

const initialState = Immutable.fromJS({
    isDragging: false,
    draggedIds: [],
    forcedHoverEffect: null,
    dropState: null,

    // Line edge state
    attachMode: false,
    attachModeType: null,
    attachModeHoveredElementId: null,
    attachModeHoveredStack: Immutable.List(),
});

export default (state = initialState, action) => {
    switch (action.type) {
        case DRAG_START:
            return state.set('dropState', null).set('isDragging', true).set('draggedIds', Immutable.List(action.ids));
        case DRAG_END:
            return Immutable.fromJS({
                isDragging: false,
                draggedIds: [],
                forcedHoverEffect: null,
                dropState: action.dropState,

                attachMode: false,
                attachModeType: null,
                attachModeHoveredElementId: null,
                attachModeHoveredStack: Immutable.List(),
            });
        case USER_NAVIGATE:
        case DND_3D_EFFECTS_SET:
            return state.set('dropState', null);
        case FORCE_HOVER_EFFECT:
            return state.set('forcedHoverEffect', action.effect);
        case CLEAR_HOVER_EFFECT:
            return state.set('forcedHoverEffect', null);
        // Line edge updates
        case ATTACH_MODE_START:
            return state
                .set('attachMode', true)
                .set('attachModeType', action.attachModeType)
                .set('attachModeHoveredElementId', action.hoveredElementId)
                .update('attachModeHoveredStack', (stack) => stack.push(action.hoveredElementId));
        case ATTACH_MODE_END: {
            let currentlyHoveredStack = state.get('attachModeHoveredStack');

            const currentlyHoveredStackIndex = currentlyHoveredStack.indexOf(action.hoveredElementId);
            currentlyHoveredStack =
                currentlyHoveredStackIndex !== -1
                    ? currentlyHoveredStack.delete(currentlyHoveredStackIndex)
                    : currentlyHoveredStack;

            const newHoveredId = currentlyHoveredStack.last();

            return state
                .set('attachMode', !!newHoveredId)
                .set('attachModeHoveredElementId', newHoveredId)
                .set('attachModeHoveredStack', currentlyHoveredStack);
        }
        case LINE_POINT_DRAG_START:
            return state
                .set('attachMode', false)
                .set('attachModeType', null)
                .set('attachModeHoveredElementId', null)
                .set('attachModeHoveredStack', Immutable.List());
        default:
            return state;
    }
};
